import { render, staticRenderFns } from "./CompactCampaignsTable.vue?vue&type=template&id=5586e7ef&scoped=true"
import script from "./CompactCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./CompactCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./CompactCampaignsTable.vue?vue&type=style&index=0&id=5586e7ef&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586e7ef",
  null
  
)

export default component.exports